import React from 'react';
import LogoEditorial from '../../images/logo_cardinal.svg';


import './Header.scss';

const Header = () => {
  return (
    <div className='menu_superior'>
        <div className='logo'>
            <img src={LogoEditorial} />
        </div>
        <div className='datos_menu'>
            <div className='title_text'>
                <p>Comprensión de lectura 5 - Lectura 1</p>
            </div>
            <div className='activity'>
                <p><strong>Actividad: </strong>Elige una artesanía, colorea, descárgala y pégala en el libro. </p>
            </div>
        </div>
    </div>
  )
}

export default Header